module.exports = {
  header: {
    title: 'Launch Features',
    titlePaid: 'Paid Features',
    titleShowHide: 'Show/Hide Features',
    footer: {
      launch: `The Launch Features section allows admins to enable or disable access to various features within the app. When a feature's toggle is switched off, that feature will become inaccessible for all users within the app, indicated by a greyed-out button. When the toggle is switched on, the feature becomes available for use.`,
      showHide: `The Show/Hide Features section allows admins to effectively manage the visibility of various features within the app. If a feature's toggle is switched off, that feature will be hidden from all users in the app. Conversely, if the toggle is switched on, the feature will be displayed.`,
      paid: `The Paid Features section provides admins the ability to manage access to premium features within the app. If a feature's toggle is switched off, that feature becomes inaccessible (greyed-out) for all users in the app. When the toggle is switched on, the feature becomes available for use, typically for users who have Champion subscription.`,
    },
  },
  table: {
    title: {
      index: 'NO',
      enable: 'ENABLE/DISABLE',
      feature: 'FEATURE',
      description: 'DESCRIPTION',
    },
    tooltip: {
      disable: 'Disable',
      enable: 'Enable',
    },
    popup: {
      title: 'Confirm',
      okBtn: 'Yes',
      cancelBtn: 'No',
      enable: 'Do you want to enable <bold>{{feature}}</bold>?',
      disable: 'Do you want to disable <bold>{{feature}}</bold>?',
      confirmPassword: 'Please input your password to confirm.',
    },
  },
};
